import { SparkleIcon } from "@phosphor-icons/react";
import { motion } from "framer-motion";

/**
 * Stage-1 banner — surfaces the free-tier offer above the header on desktop.
 * Localized inline (not via Lingui) because Hebrew is the canonical copy.
 */
export const DonationBanner = () => (
  <motion.a
    href="/auth/register"
    initial={{ opacity: 0, y: -50, height: 36 }}
    animate={{ opacity: 1, y: 0, transition: { duration: 0.3 } }}
    className="hidden w-screen items-center justify-center gap-x-2 bg-zinc-900 font-sans text-xs font-medium leading-relaxed text-zinc-50 lg:flex"
    dir="rtl"
  >
    <SparkleIcon weight="fill" size={14} className="shrink-0 text-amber-400" />
    <span>
      שלב השקה — כל המסלולים <strong>חינם</strong>. הקמת תשתית התרעות פיקוד העורף לקבוצות WhatsApp בלי תשלום.
    </span>
  </motion.a>
);
